import * as React from 'react';
import classNames from 'classnames';
import './Checkbox.scss';
import Icon from '../Icon';

export interface ICheckboxProps extends React.HTMLProps<HTMLInputElement> {
  children?: any;
  inline?: boolean;
}

const Checkbox = (props: ICheckboxProps) => {
  const { className, children, inline, ...checkboxProps } = props;
  const { id } = props;

  return (
    <label
      htmlFor={id}
      className={classNames(
        'Checkbox',
        className,
      )}
    >
      <input {...checkboxProps} type="checkbox" className="Checkbox-Input" />
      <span className="Checkbox-Btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="Checkbox-Icon">
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 8l3 3 5-5"
          />
        </svg>
      </span>
      {children && (<span className="ml-2">{children}</span>)}
    </label>
  );
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/FormElements/Checkbox.tsx